/**
 * Represents a number in a byte unit
 */
export var Byte;
(function (Byte) {
    /**
     * Kilobytes (1024^1)
     */
    Byte[Byte["KILO"] = 1024] = "KILO";
    /**
     * Megabytes (1024^2)
     */
    Byte[Byte["MEGA"] = 1048576] = "MEGA";
    /**
     * Gigabytes (1024^3)
     */
    Byte[Byte["GIGA"] = 1073741824] = "GIGA";
    /**
     * Terabytes (1024^4)
     */
    Byte[Byte["TERA"] = 1099511627776] = "TERA";
    /**
     * Petabytes (1024^5)
     */
    Byte[Byte["PETA"] = 1125899906842624] = "PETA";
})(Byte || (Byte = {}));
//# sourceMappingURL=Byte.js.map